import { sliderData } from '@anm/data/pricing/sliderData';
import arrayToObject from '@anm/helpers/array/arrayToObject';
import { getVideoData } from '@anm/helpers/waveVideo';
import { Manifest } from '@anm/hosting-player';
import { useEffect, useState } from 'react';

export default (isProd = true) => {
  const [videosManifest, setVideosManifest] = useState<{
    [key: string]: Manifest;
  }>();
  const videoIds = sliderData.map(s => s.videoId);

  useEffect(() => {
    (async () => {
      const resp = await getVideoData(videoIds, isProd);
      const manifests = arrayToObject(resp);
      setVideosManifest(manifests);
    })();
  }, []);

  return videosManifest;
};
